enum RolesManage {
  MANAGE_CUSTOMERS = 'manage-customers',
  MANAGE_USERS = 'manage-users',
  MANAGE_GROUPS = 'manage-groups',
  MANAGE_CONTRACTS_MOT = 'manage-contracts-mot',
  MANAGE_REQUESTS_MOT = 'manage-requests-mot',
  MANAGE_GROUPINGS = 'manage-groupings',
  MANAGE_DEPARTMENTS = 'manage-departments',
  MANAGE_BANNERS = 'manage-banners',
  MANAGE_ALERTS = 'manage-alerts',
  MANAGE_SERVICE_REQUESTS = 'manage-service-requests',
  LORAWAN_MOT_MANAGE_CONTRACTS = 'lorawan-mot-manage-contracts',
  LORAWAN_MOT_MANAGE_REQUESTS = 'lorawan-mot-manage-requests',
  LORAWAN_MOT_MANAGE_GROUPINGS = 'lorawan-mot-manage-groupings',
  MANAGE_PERSONALIZATION = 'manage-personalization',
  MANAGE_SMS_CONTRACT = 'manage-sms-contract',
  MANAGE_PLANS = 'manage-plans',
  MANAGE_SHARED_PLANS = 'manage-shared-plans',
  MANAGE_CONSUMPTION_ALERTS = 'manage-consumption-alerts',
  MANAGE_SEND_EMAIL_CONFIGURATION = 'manage-send-email-configuration',
  LORAWAN_MANAGE_CONNECTIONS = 'lorawan-manage-connections',
}

export enum RolesView {
  VIEW_CUSTOMERS = 'view-customers',
  VIEW_USERS = 'view-users',
  VIEW_INVOICES = 'view-invoices',
  VIEW_SMS = 'view-sms',
  VIEW_SENDERS = 'sms-senders',
  VIEW_ADDONS = 'view-addons',
  VIEW_GROUPS = 'view-groups',
  CALL_CENTER = 'call-center',
  ACTIONS_QUEUE = 'actions-queue',
  DASHBOARD = 'dashboard',
  MANAGEMENT = 'management',
  DEVICES = 'devices',
  APPLICATIONS = 'applications',
  VIEW_ROAMING = 'view-roaming',
  VIEW_CONSUME = 'view-consume',
  LINES_INFO = 'lines-info',
  VIEW_TPDU = 'view-tpdu',
  VIEW_TPDU_ACQUIRING = 'view-tpdu-acquiring',
  VIEW_AUTHENTICATIONS = 'view-authentications',
  VIEW_COVERAGE_MAP = 'view-coverage-map',
  VIEW_REPORTS = 'view-reports',
  VIEW_GRAFANA_MONITOR = 'view-grafana-monitor',
  VIEW_GRAFANA_ESPECIALIST = 'view-grafana-especialist',
  VIEW_CONTRACTS = 'view-contracts',
  VIEW_AUTOSERVICES = 'view-autoservices',
  VIEW_TRANSFERS = 'view-transfers',
  VIEW_GROUPINGS = 'view-groupings',
  VIEW_INVOICE_ACTIONS = 'view-invoice-actions',
  VIEW_SUBSCRIBER_INFO = 'view-subscriberInfos',
  VIEW_OPERATIONS = 'view-operations',
  VIEW_DEPARTAMENTS = 'view-departaments',
  VIEW_INVOICES_MOT = 'view-invoices-mot',
  VIEW_REQUESTS_MOT = 'view-requests-mot',
  VIEW_CONTRACTS_MOT = 'view-contracts-mot',
  VIEW_REQUESTS_TRACKING = 'view-requests-tracking',
  VIEW_DIAGNOSTICS = 'view-diagnostics',
  VIEW_APN = 'view-apn',
  VIEW_ALERTS = 'view-alerts',
  VIEW_SERVICE_REQUESTS = 'view-service-requests',
  VIEW_SHARED_PLANS = 'view-shared-plans',
  // LORAWAN
  LORAWAN_NEW = 'lorawan-new',
  LORAWAN_VIEW_ORG = 'lorawan-view-org',
  LORAWAN_VIEW_DASHBOARDS = 'lorawan-view-dashboards',
  LORAWAN_VIEW_DEVICES = 'lorawan-view-devices',
  LORAWAN_VIEW_ACTIONS_QUEUE = 'lorawan-view-actions-queue',
  LORAWAN_VIEW_REFERRALS = 'lorawan-view-referrals',
  LORAWAN_VIEW_DEVICE_PROFILES = 'lorawan-view-device-profiles',
  LORAWAN_VIEW_CONNECTIONS = 'lorawan-view-connections',
  // LORAWAN MOT
  LORAWAN_VIEW_CONTRACTS = 'lorawan-mot-view-contracts',
  LORAWAN_VIEW_REQUESTS = 'lorawan-mot-view-requests',
  LORAWAN_VIEW_TRANSFERS = 'lorawan-mot-view-transfers',
  LORAWAN_VIEW_GROUPINGS = 'lorawan-mot-view-groupings',
  // INSIGHTS
  INSIGHTS_BASE_EVOLUTION_VIEW = 'insights-base-evolution-view',
  INSIGHTS_ONLINE_DEVICES_VIEW = 'insights-online-devices-view',
  INSIGHTS_TRANSACTIONS_VIEW = 'insights-transactions-view',
  INSIGHTS_ALARM_CONFIGURATION = 'insights-alarm-configuration',
  INSIGHTS_ALARM_HISTORY = 'insights-alarm-history',
  INSIGHTS_ALARM_NOTIFICATION = 'insights-alarm-notification',
  // FINANCIAL
  FINANCIAL_CONSUMER_TRAFFIC_VIEW = 'financial-consumer-traffic-view',
  FINANCIAL_BILLING_VIEW = 'financial-billing-view',
  VIEW_CONSUMPTION_ALERTS = 'view-consumption-alerts',
  // API
  VIEW_API_DASHBOARDS = 'view-api-dashboards',
}

export enum RolesActions {
  BATCH_ACTIONS = 'batch-actions',
  SIMCARD_IMPORT = 'simcard-import',
  SIMCARD_RESET = 'simcard-reset',
  NETWORK_RESET = 'network-reset',
  CONTRACT_MOVEMENT = 'contract-movement',
  PRIORITY_CHANGE = 'priority-change',
  PRIORITY_CHANGE_CONNECT_ONE = 'priority-change-connect-one',
  OPERATOR_RESTRICTION = 'operator-restriction',
  CONTRACT_SUSPEND = 'contract-suspend',
  SEND_SMS = 'send-sms',
  SMS_BLOCK = 'sms-block',
  REQUEST_REPORT = 'request-report',
  FINANCIAL_LOCK_UNLOCK = 'financial-lock-unlock',
  DOWNLOAD_INVOICES = 'download-invoices',
  NETWORK_BLOCK_UNLOCK = 'network-block-unlock',
  NICKNAME_CHANGE = 'nickname-change',
  TRANSFER = 'transfer',
  MSISDN_EXCHANGE = 'msisdn-exchange',
  MANUAL_ACTIVATION = 'manual-activation',
  ADD_CREDIT_TO_CONTRACT = 'add-credit-to-contract',
  IMEI_LOCK_UNLOCK = 'imei-lock-unlock',
  SUSPENSION = 'suspension',
  SUSPENSION_WITHDRAWAL = 'suspension-withdrawal',
  FORCE_REACTIVATION = 'force-reactivation',
  PLASTIC_EXCHANGE = 'plastic-exchange',
  ADD_CREDIT_TO_SIMCARD = 'add-credit-to-simcard',
  BATCH_PERMISSIONS = 'batch-permissions',
  ADD_ITEMS_TO_INVOICE = 'add-items-to-invoice',
  IMEI_LOCK = 'imei-lock',
  IMEI_UNLOCK = 'imei-unlock',
  WITHDRAWAL = 'withdrawal',
  MOT_DEACTIVATION = 'mot-deactivation',
  BROKER_CANCELLATION = 'broker-cancellation',
  HLR_REPROG = 'hlr-reprog',
  MOT_OPERATOR_CHANGE = 'mot-operator-change',
  LORAWAN_ACTIVATION = 'lorawan-activation',
  LORAWAN_DEACTIVATION = 'lorawan-deactivation',
  LORAWAN_CHANGE_TAGS = 'lorawan-change-tags',
  LORAWAN_CHANGE_DESCRIPTION = 'lorawan-change-description',
  LORAWAN_UPLINK_BLOCK_UNLOCK = 'lorawan-uplink-block-unlock',
  LORAWAN_DOWNLINK_BLOCK_UNLOCK = 'lorawan-downlink-block-unlock',
  LORAWAN_UPDATE_ORG = 'lorawan-update-org',
  LORAWAN_REFERRALS = 'lorawan-referrals',
  LORAWAN_DOWNLINK_SCHEDULE = 'lorawan-downlink-schedule',
  LORAWAN_DELETING_REFERRALS = 'lorawan-deleting-referrals',
  LORAWAN_TRANSFERS = 'lorawan-transfers',
  LORAWAN_IMPORT = 'lorawan-import',
  LORAWAN_REPORT = 'lorawan-report',
  LORAWAN_CONNECTING_LINK = 'lorawan-connecting-link',
  LORAWAN_SUSPENSION_REACTIVATION = 'lorawan-suspension-reactivation',
  APN_ADD = 'apn-add',
  APN_REMOVE = 'apn-remove',
  MANAGEMENT_REPORT = 'management-report',
  MANAGEMENT_CANCELLATION_REPORT = 'management-cancellation-report',
  REQUEST_CUSTOMER_REPORT = 'request-customer-report',
  CHANGE_APN = 'change-apn',
  MANAGE_APN = 'manage-apn',
  ADD_CREDIT_TO_SHARED_PLAN = 'add-credit-to-shared-plan',
  ALGAR_BAIT_RENEWAL = 'algar-bait-renewal',
  BAIT_RENEWAL = 'bait-renewal',
  USE_BLOCK_UNBLOCK = 'use-block-unblock',
  INSIGHTS_TRANSACTIONS_ALARM_MANAGE_CONFIGURATION = 'insights-transactions-alarm-manage-configuration',
  INSIGHTS_ALARM_MANAGE_CONFIGURATION = 'insights-alarm-manage-configuration',
  SYNC_APN = 'sync-apn',
  CANCELLATION = 'cancellation',
  CHANGE_SIMCARD = 'change-simcard',
  REQUEST_CONSUMPTION_REPORT = 'request-consumption-report',
  REQUEST_LOCATION_REPORT = 'request-location-report',
  REQUEST_CONSUMPTION_LOCATION_REPORT = 'request-consumption-location-report',
}

export enum RolesInventColumns {
  INVENT_CONSUMPTION = 'consumptionTotal',
  INVENT_FRANCHISING = 'franchising',
  INVENT_IMEI = 'imei',
  INVENT_RAT = 'rat',
  INVENT_CUSTOMER_NAME = 'customerName',
  INVENT_AUTOMATIC_BLOCKING = 'automaticBlocking',
  INVENT_BLOCKING_TYPE = 'blockingType',
  INVENT_IMSI = 'imsi',
  INVENT_OPERATOR = 'operator',
  INVENT_ONLINE = 'online',
  INVENT_PLAN = 'plan',
  INVENT_LAST_CONNECTION = 'lastConnection',
  INVENT_STATUS = 'status',
  INVENT_PRICE = 'price',
  INVENT_CPF_CNPJ = 'cpfCnpj',
  INVENT_NICKNAME = 'nickname',
  INVENT_ICCID = 'iccid',
  INVENT_HOSTNAME = 'hostname',
  INVENT_ISCA = 'isca',
  INVENT_LAST_ALERT_DATE = 'lastAlertDate',
  INVENT_CONN_OPERATOR = 'connOperator',
  INVENT_MSISDN = 'msisdn',
  INVENT_ACTIVATION_DATE = 'activationDate',
  INVENT_APN = 'apn',
  INVENT_ACTIVATION_PRICE = 'activationPrice',
  INVENT_CONNECTED_OPERATOR = 'connectedOperator',
  INVENT_IMEI_LOCKED = 'imeiLocked',
  INVENT_CONTRACT_ASSET_NUMBER = 'contractAssetNumber',
  INVENT_SUB_OPERATOR = 'subOperator',
  INVENT_OBSERVATION = 'observation',
  INVENT_DEVICE = 'device',
  INVENT_FRANCHISE = 'franchise',
  INVENT_CUSTOMER_DOCUMENT_NUMBER = 'customerDocumentNumber',
  INVENT_CITY = 'city',
  INVENT_STATE = 'state',
  INVENT_NETWORK_BLOCK_STATUS = 'networkBlockStatus',
  INVENT_BLOCKED_BY_DEFAULT = 'blockedByDefault',
  INVENT_ACCOUNT_ID = 'accountId',
  INVENT_ACCOUNT_DES = 'accountDesc',
  INVENT_LOYALTY_TYPE = 'loyaltyType',
  INVENT_LOYALTY_TIME = 'loyaltyTime',
  INVENT_TRADE_IN_MONTHS = 'tradeInMonths',
  INVENT_PRE_ACTIVATION_DAYS = 'preActivationDays',
  INVENT_SHARING_TYPE = 'sharingType',
  INVENT_BROKER_CONTRACT_ID = 'brokerContractId',
  INVENT_BROKER_CONTRACT_DESC = 'brokerContractDesc',
  INVENT_CANCELLATION_DATE = 'cancellationDate',
  INVENT_MEGABYTE_EXC_PRICE = 'mbExcPrice',
  INVENT_SIMCARD_CREDIT = 'simcardCredit',
  INVENT_PRE_ACTIVATION_END_DATE = 'preActivationEnd',
  INVENT_CONTRACT_CREDIT = 'sharedCredit',
  INVENT_SUSPENSION_ELIGIBILITY = 'eligibleToSuspension',
  INVENT_TECHNOLOGY = 'technology',
  INVENT_POSTAL_CODE = 'postalCode',
  INVENT_SHARED_CONTRACT_FRANCHISE = 'sharedFranchise',
  INVENT_SUSPENSION_START_DATE = 'suspensionStartDate',
  INVENT_ACCOUNT_CREDIT = 'accountCredit',
  INVENT_LAST_UPDATE_STATUS = 'lastStatusUpdate',
  INVENT_LAST_UPDATE = 'lastUpdate',
  INVENT_PARENT_DOCUMENT_NUMBER = 'parentDocumentNumber',
  INVENT_BLOCK_BY_DEFAULT = 'blockedByDefault',
  INVENT_ROAMING = 'roaming',
  INVENT_PENALTY = 'penalty',
  INVENT_APN_PROVISIONED = 'apns',
  INVENT_PLANTYPE = 'planType',
  INVENT_AUTOMATIC_RENEWAL = 'automaticRenewal',
  INVENT_ISCA_MAX_RENEWAL = 'iscaMaxRenewal',
  INVENT_NU_RENEWALS = 'nuRenewals',
  INVENT_PARENT_NAME = 'parentName',
}

export enum RolesInventMoreInfo {
  INVENT_ASSET_ID = 'assetId',
  INVENT_ACRONYM = 'acronym',
  INVENT_BLOCKING_INITIAL_DATE = 'blockingInitialDate',
  INVENT_BLOCKING_FINAL_DATE = 'blockingFinalDate',
  INVENT_OBSERVATION = 'observation',
  INVENT_ZIP_CODE = 'zipCode',
  INVENT_PARENT_ID = 'parentId',
  INVENT_ID = 'id',
  INVENT_CUSTOMER_ID = 'customerId',
  INVENT_LATITUDE = 'latitude',
  INVENT_CONSUMPTION_CURRENT_DAY = 'consumptionCurrentDay',
  INVENT_LONGITUDE = 'longitude',
  INVENT_CONSUMPTION_PERCENT = 'consumptionPercent',
  INVENT_ID_VIRTUAL_ACCOUNT = 'idVirtualAccount',
  INVENT_STATE = 'state',
  INVENT_CITY = 'city',
  INVENT_LOGIC_NUMBER = 'logicNumber',
  INVENT_CONSUMPTION_VALIDATED = 'consumptionValidated',
  INVENT_ASSET_PARENT_IOT = 'assetParentIot',
  INVENT_LOCATION_INFO = 'locationInfo',
  INVENT_SIMCARD_CREDIT = 'simcardCredit',
  INVENT_ACCOUNT_CREDIT = 'accountCredit',
  INVENT_SUSPENSION_INITIAL_DATE = 'suspensionInitialDate',
  INVENT_SUSPENSION_FINAL_DATE = 'suspensionFinalDate',
  INVENT_IMEI_LOCKED = 'imeiLocked',
  INVENT_IS_SUSPENDABLE = 'isSuspendable',
  INVENT_NETWORK_BLOCK_START_DATE = 'networkBlockStartDate',
  INVENT_NETWORK_BLOCK_END_DATE = 'networkBlockEndDate',
  INVENT_POSTAL_CODE = 'postalCode',
  INVENT_ACCOUNT_ID = 'accountId',
  INVENT_DEVICE_NUMBER = 'deviceNumber',
  INVENT_SUSPENSION_START_DATE = 'suspensionStartDate',
  INVENT_SUSPENSION_END_DATE = 'suspensionEndDate',
}

export enum RolesPublicApi {
  API_ATTENDANCE_RESET_HLR = 'api-attendance-reset-hlr',
  API_ATTENDANCE_RESET_OTA = 'api-attendance-reset-ota',
  API_ATTENDANCE_RESET_VIEW = 'api-attendance-reset-view',
  API_BROKER_CUSTOMERS_CREATE = 'api-broker-customers-create',
  API_BROKER_ORDER_CREATE = 'api-broker-order-create',
  API_BROKER_ORDER_VIEW = 'api-broker-order-view',
  API_BROKER_PLANS_CREATE = 'api-broker-plans-create',
  API_BROKER_PLANS_VIEW = 'api-broker-plans-view',
  API_BROKER_QUOTA_VIEW = 'api-broker-quota-view',
  API_BROKER_TRANSFER = 'api-broker-transfer',
  API_BROKER_TRANSFER_VIEW = 'api-broker-transfer-view',
  API_BROKER_VIRTUAL_ACCOUNTS_CREATE = 'api-broker-virtual-accounts-create',
  API_BROKER_VIRTUAL_ACCOUNTS_INVOICES_USAGE_VIEW = 'api-broker-virtual-accounts-invoices-usage-view',
  API_BROKER_VIRTUAL_ACCOUNTS_INVOICES_VIEW = 'api-broker-virtual-accounts-invoices-view',
  API_DEVICE_MANAGEMENT_ACTION = 'api-device-management-action',
  API_DEVICE_MANAGEMENT_ACTION_VIEW = 'api-device-management-action-view',
  API_DEVICE_MANAGEMENT_ACTIONS_VIEW = 'api-device-management-actions-view',
  API_DEVICE_MANAGEMENT_CANCELLATION = 'api-device-management-cancellation',
  API_DEVICE_MANAGEMENT_CANCELLATION_VIEW = 'api-device-management-cancellation-view',
  API_DEVICE_MANAGEMENT_CHANGE_SIMCARD = 'api-device-management-change-simcard',
  API_DEVICE_MANAGEMENT_CHANGE_SIMCARD_VIEW = 'api-device-management-change-simcard-view',
  API_DEVICE_MANAGEMENT_CONTRACTS_VIEW = 'api-device-management-contracts-view',
  API_DEVICE_MANAGEMENT_NETWORK_SUSPENSION = 'api-device-management-network-suspension',
  API_DEVICE_MANAGEMENT_OPERATOR_PRIORITY = 'api-device-management-operator-priority',
  API_DEVICE_MANAGEMENT_OPERATOR_PRIORITY_VIEW = 'api-device-management-operator-priority-view',
  API_DEVICE_MANAGEMENT_PROVISIONAL_SUSPENSION = 'api-device-management-provisional-suspension',
  API_DEVICE_MANAGEMENT_PROVISIONAL_SUSPENSION_VIEW = 'api-device-management-provisional-suspension-view',
  API_DEVICE_MANAGEMENT_RESET = 'api-device-management-reset',
  API_DEVICE_MANAGEMENT_RESET_HLR = 'api-device-management-reset-hlr',
  API_DEVICE_MANAGEMENT_RESET_HLR_VIEW = 'api-device-management-reset-hlr-view',
  API_DEVICE_MANAGEMENT_RESET_OTA = 'api-device-management-reset-ota',
  API_DEVICE_MANAGEMENT_RESET_OTA_VIEW = 'api-device-management-reset-ota-view',
  API_DEVICE_REPORT = 'api-device-report',
  API_DEVICES_QUOTA_VIEW = 'api-devices-quota-view',
  API_DEVICES_SESSION_VIEW = 'api-devices-session-view',
  API_DEVICES_VIEW = 'api-devices-view',
  API_INVOICES_CLOSED_USAGE_VIEW = 'api-invoices-closed-usage-view',
  API_INVOICES_CLOSED_VIEW = 'api-invoices-closed-view',
  API_INVOICES_OPEN_USAGE_VIEW = 'api-invoices-open-usage-view',
  API_INVOICES_OPEN_VIEW = 'api-invoices-open-view',
  API_NETWORKS_SMS = 'api-networks-sms',
  API_NETWORKS_SMS_BLOCKED = 'api-networks-sms-blocked',
  API_REPORT_VIEW = 'api-report-view',
  API_BROKER_ADD_CONTRACT_CREDIT = 'api-broker-add-contract-credit',
  API_SESSION_HISTORY_VIEW = 'api-session-history-view',
  API_BROKER_UNLOCK_FINANCIAL = 'api-broker-unlock-financial',
  API_BROKER_BLOCK_FINANCIAL = 'api-broker-block-financial',
  API_BROKER_ADD_CREDIT = 'api-broker-add-credit',
  API_BROKER_CHANGE_MSISDN = 'api-broker-change-msisdn',
  API_DEVICE_MANAGEMENT_REPROGRAM_SUBSCRIBER = 'api-device-management-reprogram-subscriber',
  API_REQUEST_SMS = 'api-request-sms',
  API_REQUEST_SMS_VIEW = 'api-request-sms-view',
  API_SMS_VIEW = 'api-sms-view',
  API_BROKER_OPERATIONS_VIEW = 'api-broker-operations-view',
  API_BROKER_SUBSTITUTION = 'api-broker-substitution',
  API_BROKER_SUSPENSION = 'api-broker-suspension',
  API_BROKER_SUSPENSION_CANCELLATION = 'api-broker-suspension-cancellation',
  API_BROKER_SUSPENSION_REVERSE = 'api-broker-suspension-reverse',
  API_BROKER_CUSTOMER_VIEW = 'api-broker-customer-view',
}

const RolesInventory = {
  ...RolesInventColumns,
  ...RolesInventMoreInfo,
};

const rolesConstants = {
  ...RolesManage,
  ...RolesView,
  ...RolesActions,
  ...RolesInventory,
  ...RolesPublicApi,
};

export type RolesTypes =
  | RolesManage
  | RolesView
  | RolesActions
  | RolesInventColumns
  | RolesInventMoreInfo
  | RolesPublicApi;

export default rolesConstants;
